import type { ForestMarketLevel } from "./types";

export const FOREST_MARKET_LEVELS: readonly ForestMarketLevel[] = [
  {
    id: "math-forest-market-1",
    domain: "math",
    activityType: "forest-market",
    difficulty: 1,
    objectives: ["用实物理解三以内的合并"],
    title: "苹果放一起",
    instruction: "篮子里有一个苹果，又来一个作伴。现在一共有几个苹果？",
    promptAudio: "/audio/voice/math/forest-market-1.ogg",
    assets: [],
    payload: {
      itemId: "apple",
      operation: "add",
      startingCount: 1,
      changeCount: 1,
      choices: [
        { id: "one", count: 1 },
        { id: "two", count: 2 },
        { id: "three", count: 3 }
      ],
      correctChoiceId: "two"
    }
  },
  {
    id: "math-forest-market-2",
    domain: "math",
    activityType: "forest-market",
    difficulty: 2,
    objectives: ["用实物理解三以内的拿走"],
    title: "胡萝卜回家",
    instruction: "三根胡萝卜躺在篮子里，拿走一根。现在还剩几根？",
    promptAudio: "/audio/voice/math/forest-market-2.ogg",
    assets: [],
    payload: {
      itemId: "carrot",
      operation: "subtract",
      startingCount: 3,
      changeCount: 1,
      choices: [
        { id: "two", count: 2 },
        { id: "three", count: 3 },
        { id: "one", count: 1 }
      ],
      correctChoiceId: "two"
    }
  },
  {
    id: "math-forest-market-3",
    domain: "math",
    activityType: "forest-market",
    difficulty: 3,
    objectives: ["完成五以内的加法"],
    title: "莓果小篮子",
    instruction: "篮子里有两颗莓果，又滚进来三颗。现在一共有几颗？",
    promptAudio: "/audio/voice/math/forest-market-3.ogg",
    assets: [],
    payload: {
      itemId: "berry",
      operation: "add",
      startingCount: 2,
      changeCount: 3,
      choices: [
        { id: "four", count: 4 },
        { id: "five", count: 5 },
        { id: "three", count: 3 }
      ],
      correctChoiceId: "five"
    }
  },
  {
    id: "math-forest-market-4",
    domain: "math",
    activityType: "forest-market",
    difficulty: 4,
    objectives: ["完成五以内的减法"],
    title: "玉米分一分",
    instruction: "五根玉米送给朋友两根。篮子里还剩几根？",
    promptAudio: "/audio/voice/math/forest-market-4.ogg",
    assets: [],
    payload: {
      itemId: "corn",
      operation: "subtract",
      startingCount: 5,
      changeCount: 2,
      choices: [
        { id: "two", count: 2 },
        { id: "four", count: 4 },
        { id: "three", count: 3 }
      ],
      correctChoiceId: "three"
    }
  },
  {
    id: "math-forest-market-5",
    domain: "math",
    activityType: "forest-market",
    difficulty: 5,
    objectives: ["完成十以内的加法"],
    title: "梨子装满篮",
    instruction: "四个梨在篮子里，又放进来五个。现在一共有几个梨？",
    promptAudio: "/audio/voice/math/forest-market-5.ogg",
    assets: [],
    payload: {
      itemId: "pear",
      operation: "add",
      startingCount: 4,
      changeCount: 5,
      choices: [
        { id: "eight", count: 8 },
        { id: "ten", count: 10 },
        { id: "nine", count: 9 }
      ],
      correctChoiceId: "nine"
    }
  },
  {
    id: "math-forest-market-6",
    domain: "math",
    activityType: "forest-market",
    difficulty: 6,
    objectives: ["完成十以内的减法"],
    title: "蘑菇送朋友",
    instruction: "九朵蘑菇在篮子里，拿走四朵。数一数，还剩几朵？",
    promptAudio: "/audio/voice/math/forest-market-6.ogg",
    assets: [],
    payload: {
      itemId: "mushroom",
      operation: "subtract",
      startingCount: 9,
      changeCount: 4,
      choices: [
        { id: "four", count: 4 },
        { id: "five", count: 5 },
        { id: "six", count: 6 }
      ],
      correctChoiceId: "five"
    }
  }
];
